import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import HorizontalBarChart from '@/assets/common/HorizontalBarChart/HorizontalBarChart.vue';
import { AgriFieldGroupIncomeOutgoOutline, AgriFieldIncomeOutgoOutline, CropsIncomeOutgoOutline, CropIncomeOutgoOutline } from '@/types/Component';


interface ChartData {
    labels?: string[];
    datasets: Dataset[]
}

interface Dataset {
    yAxisID?: string;
    type?: string;
    label?: string;
    backgroundColor?: string | any;
    borderColor?: string;
    fill?: boolean;
    data: number[];
    barThickness?: number;
}

@Component({
    components: {
        HorizontalBarChart
    }
})
export default class IncomeAndOutgoChart extends Vue {
    private chartData!: ChartData
    private options: any = {}

    @Prop()
    private incomeAndOutgoItems!: AgriFieldGroupIncomeOutgoOutline[] | AgriFieldIncomeOutgoOutline[] | CropsIncomeOutgoOutline[] | CropIncomeOutgoOutline[]
    @Prop()
    private isWidget!: boolean

    @Watch('incomeAndOutgoItems')
    private onChangeIncomeAndOutgo(): void {
        const labels = []
        const data = []
        const incomeAndOutgoItems = this.incomeAndOutgoItems
        const isWidget = this.isWidget
        for (const item of this.incomeAndOutgoItems){
            const fieldName = (item as AgriFieldGroupIncomeOutgoOutline).agriFieldGroupName
                || (item as AgriFieldIncomeOutgoOutline).agriFieldName
                || (item as CropsIncomeOutgoOutline).cropName
                || (item as CropIncomeOutgoOutline).plantingName
            let label = fieldName.length > 16 ? fieldName.substring(0, 16) + '…' : fieldName
            if(this.isWidget) {
                label = fieldName.length > 5 ? fieldName.substring(0, 5) + '…' : fieldName
            }
            labels.push(label)
            data.push(item.income - item.outgo)
        }
        this.chartData = {
            labels: labels,
            datasets: [
                {
                    data: data,
                    backgroundColor: this.setColor,
                    barThickness: this.isWidget ? 30 : undefined
                }
            ]
        }

        this.options = {
            maintainAspectRatio: false,
            responsive: true,
            legend: {
                display: false
            },
            tooltips: {
                callbacks: {
                    title: function (tooltipItem: any, data: any) {
                        let value = (incomeAndOutgoItems[tooltipItem[0].index] as AgriFieldGroupIncomeOutgoOutline).agriFieldGroupName
                            || (incomeAndOutgoItems[tooltipItem[0].index] as AgriFieldIncomeOutgoOutline).agriFieldName
                            || (incomeAndOutgoItems[tooltipItem[0].index] as CropsIncomeOutgoOutline).cropName
                            || (incomeAndOutgoItems[tooltipItem[0].index] as CropIncomeOutgoOutline).plantingName
                        if(isWidget) {
                            // ウィジェットのグラフだったら25文字で改行する
                            const splitValue = []
                            for (let i = 0; i < value.length; i+=25) {
                                splitValue.push(value.slice(i, i+25))
                            }
                            value = splitValue.join('\n')
                        }
                        return value
                    },
                    label: function (tooltipItem: any, data: any) {
                        const value = data.datasets[0].data[tooltipItem.index]
                        if(value < 0) {
                            return '▲' + Math.abs(value).toLocaleString() + '円'
                        }else {
                            return value.toLocaleString() + '円'
                        }
                    }
                }
            },
            scales: {
                xAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function(value: any) {
                            let tick
                            if(value < 0){
                                tick = '▲ ' + Math.abs(value).toLocaleString() + '円'
                            }else {
                                tick = value.toLocaleString() + '円'
                            }
                            return tick
                        }
                    }
                }]
            }
        }
    }

    private created() {
        this.onChangeIncomeAndOutgo()
    }

    get setStyle() {
        let height = (this.incomeAndOutgoItems.length * 50 + 30)

        // Chromeでは32767pxを超えるcanvas要素はレンダリングできないため、最大値を32767pxとする
        const CANVAS_HEIGHT_LIMIT = 32767
        height = (height > CANVAS_HEIGHT_LIMIT) ? CANVAS_HEIGHT_LIMIT : height

        return {
            position: 'relative',
            width: 'calc(100% - 10px)',
            height: height + 'px'
        }
    }

    private setColor(context: any): string {
        const index = context.dataIndex
        const value = context.dataset.data[index]
        return value >= 0 ? 'blue' : 'red'
    }
}